import type { ComputedRef, MaybeRefOrGetter } from 'vue';
import type {
    fetchStepRequest,
    RegenerateIdeaRequest,
    GenerateExtendIdeaRequest,
    FetchVideoResultRequest,
    ExportPptRequest,
    ExportPptPreviewRequest,
    ExportPptPreviewResponse,
    ModuleData,
    StepData,
    StepsData,
    VideoSubmitRequest,
    VideoResultResponse,
    ImageSubmitRequest,
    ImageResultResponse,
} from '../types';
import type { PatentRecallEvaluationMessageData, ModuleContentMessageData } from '@/domains/chat/types/triz-events';

export interface TrizService {
    fetchStepsData(data: fetchStepRequest): Promise<StepsData>;
    regenerateIdea(data: RegenerateIdeaRequest): Promise<StepsData>;
    getModuleData(versionNumber: number, moduleKey: string): ModuleData<any> | undefined;
    getModuleDataRef(version: MaybeRefOrGetter<number>, moduleKey: string): ComputedRef<ModuleData<any> | undefined>;
    setSolutionDetail(moduleData: ModuleData<any>): void;
    getSolutionDetail(ideaId: string): ModuleData<any> | undefined;
    setSolutionImage(moduleData: ModuleData<any>): void;
    getSolutionImage(ideaId: string): ModuleData<any> | undefined;
    setSolutionVideo(moduleData: ModuleData<any>): void;
    getSolutionVideo(ideaId: string): ModuleData<any> | undefined;
    setSolutionFlowchart(moduleData: ModuleData<any>): void;
    getSolutionFlowchart(ideaId: string): ModuleData<any> | undefined;
    getModulesData(versionNumber: number, moduleKeys: string[]): StepData;
    getVersionMeta(versionNumber: number): { id: number; business_id: string } | undefined;
    setModuleData(versionNumber: number, moduleKey: string, moduleData: ModuleData<any>): void;
    updateStepsData(modules: StepsData, versionNumber?: number): void;
    updateStepModuleStatus(versionNumber: number, moduleKey: string, ifEnd: boolean): void;
    clearVersionData(versionNumber: number): void;
    generateExtendIdea(data: GenerateExtendIdeaRequest): Promise<any>;
    mergePatentRecallData(evaluationData: PatentRecallEvaluationMessageData): void;
    mergeSolutionIdeas(message: ModuleContentMessageData): void;
    submitVideo(data: VideoSubmitRequest): Promise<any>;
    fetchVideoResult(data: FetchVideoResultRequest): Promise<VideoResultResponse>;
    submitImage(data: ImageSubmitRequest): Promise<any>;
    fetchImageResult(data: { triz_mind_id: string; idea_id: string }): Promise<ImageResultResponse>;
    exportPpt(data: ExportPptRequest): Promise<any>;
    fetchExportPptPreview(data: ExportPptPreviewRequest): Promise<ExportPptPreviewResponse>;
}

export const TrizService = Symbol('TrizService');
